import { graphql } from '@api/generated';
import { getClient } from '@api/client';

export const getWorkflowNameByPhoneNumberQuery = graphql(`
  query getWorkflowNameByPhoneNumber($phoneNumber: String!) {
    workflowNameByPhoneNumber(phoneNumber: $phoneNumber) {
      id
      name
    }
  }
`);

export type Workflow = {
  id: string;
  name: string;
};

export const getWorkflowNameByPhoneNumber = async ({
  phoneNumber,
}: {
  phoneNumber: string;
}): Promise<Workflow | null> => {
  const { data, error } = await getClient().query({
    query: getWorkflowNameByPhoneNumberQuery,
    variables: {
      phoneNumber,
    },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.workflowNameByPhoneNumber ?? null;
};
